import { getSelectedLookupOption } from './getSelectedLookupOption';
import { ProductModelInstance } from 'src/store/_models/product';

export const getSelectedLookupTitle = (
  product: ProductModelInstance | null | undefined,
  lookup_code: string,
  { i18n }: { i18n: any },
) => {
  const titleKey = (product && getSelectedLookupOption(product, lookup_code)?.titleKey) ?? '';
  return i18n.exists(`${titleKey}_selected-lookup`)
    ? i18n.t(`${titleKey}_selected-lookup`)
    : i18n.exists(titleKey)
      ? i18n.t(titleKey)
      : '';
};
